const PRODUCTION_ENVS = ["production", "blue"];

function getImageHost(): string {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT ?? "local";
  return PRODUCTION_ENVS.includes(env)
    ? "https://image.webmotors.com.br"
    : "https://himage.webmotors.com.br";
}

function buildImageUrl(imagePath: string, isCar: boolean): string {
  if (imagePath.startsWith("http")) return imagePath;

  const folder = isCar ? "AnuncioCarroUsados" : "AnuncioMotoUsados";
  return `${getImageHost()}/_fotos/${folder}/gigante/${imagePath.replace(/\\/g, "/")}`;
}

/**
 * Constrói as URLs das fotos do veículo. Quando não há fotos, retorna uma
 * lista vazia — o `VehicleCard.Image` do eleanor exibe o placeholder de
 * imagem indisponível automaticamente.
 */
export function buildImageUrls(
  photos: string[] | undefined,
  isCar: boolean
): string[] {
  if (!photos || photos.length === 0) {
    return [];
  }

  return photos.filter((p) => p !== "").map((p) => buildImageUrl(p, isCar));
}
